/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindLeadsBatchWithDocumentStatsRequest
 */
export interface FindLeadsBatchWithDocumentStatsRequest {
    /**
     * 
     */
    lead_ids: Array<string>;
}

/**
 * Check if a given object implements the FindLeadsBatchWithDocumentStatsRequest interface.
 */
export function instanceOfFindLeadsBatchWithDocumentStatsRequest(value: object): value is FindLeadsBatchWithDocumentStatsRequest {
    if (!('lead_ids' in value) || value['lead_ids'] === undefined) return false;
    return true;
}

export function FindLeadsBatchWithDocumentStatsRequestFromJSON(json: any): FindLeadsBatchWithDocumentStatsRequest {
    return FindLeadsBatchWithDocumentStatsRequestFromJSONTyped(json, false);
}

export function FindLeadsBatchWithDocumentStatsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadsBatchWithDocumentStatsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
    };
}

export function FindLeadsBatchWithDocumentStatsRequestToJSON(json: any): FindLeadsBatchWithDocumentStatsRequest {
    return FindLeadsBatchWithDocumentStatsRequestToJSONTyped(json, false);
}

export function FindLeadsBatchWithDocumentStatsRequestToJSONTyped(value?: FindLeadsBatchWithDocumentStatsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_ids': value['lead_ids'],
    };
}

